module.exports = __webpack_public_path__ + "img/product-detail-marketing-promo-bg.666d33a.jpg";